import { ContactUsPage } from '../../types/ContactUsPage'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fromStrapiContactUsPage = (strapiData: any): ContactUsPage => strapiData.attributes

export {
    fromStrapiContactUsPage,
}